import { render, staticRenderFns } from "./otcStatistic.vue?vue&type=template&id=628b4f2a&scoped=true&"
import script from "./otcStatistic.vue?vue&type=script&lang=js&"
export * from "./otcStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b4f2a",
  null
  
)

export default component.exports